<!--
 * @Description: 受理进度
--> 
<template>
  <div class="online-progress">
    <van-tabs color="#1677FF" v-model="active" @change="onChange" sticky>
      <van-tab v-for="(tab, i) in tabs" :key="i" :title="tab.title">
        <div class="tab-content">
          <div class="comm-search-bar2">
            <div class="bar-con">
              <van-field style="width:49%;" label="业务类型" readonly clickable name="picker" :value="typeName" placeholder="点击选择业务类型" @click="showPicker = true">
                <template #right-icon>
                  <span class="iconfont iconxuanzesanjiao"></span>
                </template>
              </van-field>
              <van-field style="width:49%;" v-model="bussno" label="受理编号" placeholder="" />
            </div>
            <div class="bar-btn" @click="getProgressData()">
              查询
            </div>
          </div>
          <div class="comm-seperator"></div>
          <div class="progress-info" v-for="(progress, i) in progressList" :key="i" :style="{'background': progress.fdealstatus === 3? '#9A9A9A' : '#fff'}">
            <div class="info-top-wrapper">
              <div class="info-top" style="margin-top:0;">
                <div class="info-name" :style="{'color': progress.fdealstatus === 3? '#fff' : '#333'}">业务类型：</div>
                <div class="info-value" :style="{'color': progress.fdealstatus === 3? '#fff' : '#333'}">{{progress.fnettypename}}</div>
              </div>
              <div class="info-top">
                <div class="info-name" :style="{'color': progress.fdealstatus === 3? '#fff' : '#333'}">提交时间：</div>
                <div class="info-value" :style="{'color': progress.fdealstatus === 3? '#fff' : '#333'}">{{progress.fbilldate}}</div>
              </div>
              <div class="info-top">
                <div class="info-name" :style="{'color': progress.fdealstatus === 3? '#fff' : '#333'}">受理编号：</div>
                <div class="info-value" :style="{'color': progress.fdealstatus === 3? '#fff' : '#333'}">{{progress.fbillno}}</div>
              </div>
              <div class="info-top" v-if="progress.fapplyname === '已退回'">
                <div class="info-name" :style="{'color': progress.fdealstatus === 2? '#fff' : '#333'}">退回原因：</div>
                <div class="info-value" :style="{'color': progress.fdealstatus === 2? '#fff' : '#333'}">{{progress.fnetcheckmark}}</div>
              </div>
              <div class="info-top" v-if="progress.fapplyname === '已完成'">
                <div class="info-name" :style="{'color': progress.fdealstatus === 2? '#fff' : '#333'}">处理意见：</div>
                <div class="info-value" :style="{'color': progress.fdealstatus === 2? '#fff' : '#333'}">{{progress.fnetcheckmark}}</div>
              </div>
              <div class="info-right">
                <p :style="{'color': progress.fdealstatus === 3? '#fff' : '#6096F8'}">{{progress.fapplyname}}</p>
              </div>
              <div style="text-align: right;">
                <van-button v-if="progress.fapplyname==='处理中'" class="comm-small-btn" native-type="button" color="#6096F8" @click="showClick(progress)" style="height:20px;margin-right:5px;">
                  查看
                </van-button>
                <van-button v-if="progress.fapplyname==='已退回'" class="comm-small-btn2" native-type="button" color="#6096F8" @click="rewriteClick(progress)" style="height:20px;margin-right:5px;">
                  重填
                </van-button>
                <van-button v-if="progress.fapplyname==='已退回'" class="comm-small-btn3" native-type="button" color="#6096F8" @click="abandonClick(progress)" style="height:20px;">
                  放弃
                </van-button>
              </div>
              <!-- <div class="info-top">
                <div class="info-name" :style="{'color': progress.fdealstatus === 3? '#fff' : '#333'}">办理进度：</div>
                <div class="info-value" :style="{'color': progress.fdealstatus === 3? '#fff' : '#333'}">{{progress.fnetstatusname}}
                  <van-steps :active="progress.active">
                    <van-step v-for="(process, p) in progress.processlist" :key="p">
                      {{process.stepname}}
                    </van-step>
                  </van-steps>
                  <van-steps style="width:100%;" direction="vertical" :active="progress.active">
                    <van-step v-for="(process, p) in progress.processlist" :key="p">
                      <h3>{{process.stepname}}</h3>
                      <p>{{process.dealdate}}</p>
                    </van-step>
                  </van-steps>
                </div>
              </div> -->
              <span v-if="progress.feelist&&progress.feelist.length>0">
                <div class="info-top" style="display:flex;align-items:center;" v-for="(fee, f) in progress.feelist" :key="f">
                  <div class="info-name">{{fee.chargetypename}}：</div>
                  <div class="info-value">
                    <div style="color:rgb(255, 0, 0);">{{fee.fee}}</div>
                    <div>
                      <van-button v-show="fee.status===0" color="#1677FF" size="small" type="info" class="search-btn" @click="pay(fee)">
                        立即缴纳
                      </van-button>
                      <van-button v-show="fee.status===1" disabled color="#1677FF" size="small" type="info" class="search-btn">
                        已缴费
                      </van-button>
                    </div>
                  </div>
                </div>
              </span>
            </div>
            <div v-show="false" class="info-bottom-wrapper">
              <div class="bottom-title">
                未缴费清单（<span style="color:#2C82C9">2笔</span>）
              </div>
              <div class="bottom-info">
                <div class="bottom-name">工程基准费：</div>
                <div class="bottom-value">
                  <span style="color:#FF0000">1300.00</span>&nbsp;元
                </div>
              </div>
              <div class="bottom-info">
                <div class="bottom-name">工程材料费：</div>
                <div class="bottom-value">
                  <span style="color:#FF0000">300.00</span>&nbsp;元
                </div>
              </div>
            </div>
            <div v-show="false" class="code">
              <div class="code-img">
                <img>
              </div>
              <div class="code-txt">微信、支付宝扫码缴费</div>
            </div>
          </div>
          <div style="height:17px;"></div>
          <div v-if="!progressList||progressList.length===0" style="text-align:center;">
            <img style="width:200px;" :src="require('../../assets/images/no-data.png')">
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker title="业务类型" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" :default-index="defaultIndex" />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'OnlineProgress',
  components: {
  },
  data() {
    return {
      bussno: '',
      active: 0,
      status: 1,
      typeList: this.$store.state.bussTypeList,
      typeCode: '',
      typeName: '',
      progressList: [],
      tabs: [
        {
          title: '处理中'
        },
        {
          title: '已完成'
        },
        {
          title: '无效单'
        },
        {
          title: '全部'
        }
      ],
      columns: [],
      showPicker: false,
      defaultIndex: 0
    }
  },
  mounted() {
    this.getColumns()
    if (this.$route.query.typeCode) {
      this.typeCode = this.$route.query.typeCode
      this.setTypenameByCode()
      // this.getProgressData()
    } else {
      if (this.typeList.length > 0) {
        this.typeCode = this.typeList[0].typecode
        this.typeName = this.typeList[0].typename
      }
    }
    this.onChange(this.active)
  },
  // activated() {
  //   // 前进刷新，后退缓存处理
  //   if (this.$route.meta.isUseCache) {
  //     this.$route.meta.isUseCache = false
  //   } else {
  //     if (this.$route.query.active) {
  //       this.active = Number(this.$route.query.active)
  //     }
  //   }
  // },
  beforeRouteEnter(to, from, next) {
    to.meta.isUseCache = true
    next()
  },
  methods: {
    pay(fee) {
      this.$http.post(this.$api.getPayUrl, {
        billno: fee.billno
      }).then(res => {
        if (res.code === '000') {
          window.location.href = res.data
        } else {
          this.$toast(res.msg)
        }
      })
    },
    setTypenameByCode() {
      for (let i = 0; i < this.typeList.length; i++) {
        if (this.typeCode === this.typeList[i].typecode) {
          this.typeName = this.typeList[i].typename
          this.defaultIndex = i
          break
        }
      }
    },
    showClick(progress) {
      this.jumpPage(progress, 1)
    },
    rewriteClick(progress) {
      this.jumpPage(progress, 2)
    },
    jumpPage(progress, modify) {
      this.$comm.serviceinfo(progress, modify)
    },
    abandonClick(progress) {
      this.$dialog.confirm({
        title: '确认',
        message: '确定放弃本次申请吗？'
      }).then(() => {
        this.$http.post(this.$api.billCancel, {
          bussno: progress.fbillno,
          busstype: progress.fnettype
        }).then(res => {
          if (res.code === '000') {
            this.$toast('取消成功')
            setTimeout(() => {
              this.getProgressData()
            }, 2000);
          } else {
            this.$toast(res.msg)
          }
        })
      }).catch(() => {
      })
    },
    onConfirm(obj, index) {
      this.typeName = obj.text
      this.typeCode = this.columns[index].code
      this.showPicker = false
    },
    getColumns() {
      this.$http.post(this.$api.getBasedata, {
        "typeid": 12,
        "parentid": 1
      }).then(res => {
        if (res.code === '000') {
          res.data.forEach(el => {
            this.columns.push({
              text: el.fname,
              code: el.fid
            })
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    onChange(value) {
      if (value === 0) {
        this.status = 1 // 处理中
      } else if (value === 1) {
        this.status = 2 // 已完成
      } else if (value === 2) {
        this.status = 3 // 无效单
      } else {
        this.status = null // 全部
      }
      this.getProgressData()
    },
    getProgressData() {
      this.$loading()
      this.$http.post(this.$api.businessProgress, {
        souid: 1, // 业务来源：0-非网厅 1-网厅
        busstype: this.typeCode, // 业务类型
        bussno: this.bussno, // 受理编号
        status: this.status,
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.progressList = res.data
          // eslint-disable-next-line no-debugger
          // debugger
          // for(let progress of this.progressList){
          //   progress['active'] = null
          //   for(let i=0;i<progress.processlist.length;i++){
          //     if(progress.processlist[i].status===1){
          //       progress['active'] = i
          //     }
          //     let dateStr = progress.processlist[i].dealdate
          //     dateStr = dateStr?dateStr.substring(0, 11):''
          //     progress.processlist[i].dealdate = dateStr
          //   }
          // }
        } else {
          this.$toast(res.msg)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.online-progress {
  margin: 0 10px;
  .tab-content {
    .progress-info {
      border-radius: 5px;
      position: relative;
      background: #ffffff;
      padding: 0 16px;
      margin-top: 10px;
      .info-top-wrapper {
        // background:rgba(240,246,241,1);
        border-radius: 3px;
        // border:1px solid rgba(214,216,214,1);
        padding: 10px 12px;
        .info-top {
          margin-top: 5px;
          display: flex;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(33, 33, 33, 1);
          .info-name {
            width: 70px;
          }
          .info-value {
            width: calc(~"100% - 70px");
            display: flex;
            justify-content: space-between;
            align-items: center;
            .van-steps.van-steps--horizontal {
              width: 100%;
            }
          }
        }
      }
      .info-right {
        position: absolute;
        top: 10px;
        right: 5%;
        p {
          color: #6096f8;
          font-size: 16px;
          font-weight: bold;
          font-family: PingFangSC-Medium, PingFang SC;
          margin: 0;
        }
      }
      .info-bottom-wrapper {
        margin-top: 14px;
        background: rgba(240, 246, 241, 1);
        border-radius: 3px;
        .bottom-title {
          height: 26px;
          line-height: 26px;
          padding: 0 16px;
          background: rgba(240, 246, 241, 1);
          border: 1px solid rgba(214, 216, 214, 1);
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(33, 33, 33, 1);
        }
        .bottom-info {
          display: flex;
          align-items: center;
          padding: 0 16px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(33, 33, 33, 1);
          height: 35px;
          background: #ffffff;
          border-bottom: 1px solid rgba(214, 216, 214, 1);
          border-left: 1px solid rgba(214, 216, 214, 1);
          border-right: 1px solid rgba(214, 216, 214, 1);
          .bottom-name {
            width: 84px;
          }
          .bottom-value {
            width: calc(~"100% - 84px");
            text-align: right;
          }
        }
      }
      .code {
        margin-top: 30px;
        text-align: center;
        .code-img {
          img {
            width: 168px;
            height: 168px;
          }
        }
        .code-txt {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(117, 117, 117, 1);
        }
      }
    }
  }
}
</style>